import { createContext } from "react";
export const QuickBookConnectionContext = createContext(null);
